import * as actionTypes from "./RefundTypes";

const INITIAL_STATE = {
    refundListInApproval: [],
    advanceRefundList: [],
    attachments: [],
    approvalStatus: [],
    refundListHeaderFilterData: []
};

const AdvanceRefundReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case actionTypes.SETREFUNDLIST:
            return {
                ...state,
                advanceRefundList: action.payload.list,
            };
        case actionTypes.SETREFUNDLISTINAPPROVAL:
            return {
                ...state,
                refundListInApproval: action.payload.list
            };
        case actionTypes.SETREFUNDATTACHMENTS:
            return {
                ...state,
                attachments: action.payload.list
            };
        case actionTypes.SETREFUNDAPPROVALSTATUS:
            return {
                ...state,
                approvalStatus: action.payload.list
            };
        case actionTypes.SETREFUNDLISTHEADERFILTERDATA:
            return {
                ...state,
                refundListHeaderFilterData: { ...action.payload }
            };

        default:
            return state;
    }
}

export default AdvanceRefundReducer;